if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.removeAttribute('inert');
    }

    onVariantChange() {
      // A later selection (including an invalid combination) supersedes pending section HTML.
      this.variantRequestVersion = (this.variantRequestVersion || 0) + 1;
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        const variantFallback = productForm.querySelector('[data-variant-fallback]');
        if (variantFallback) variantFallback.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      const listing = this.productWrapper.matches('[data-listing-product]');
      const version = this.variantRequestVersion;
      const variantId = this.currentVariant.id;
      const isCurrent = () => this.isConnected && version === this.variantRequestVersion && this.currentVariant?.id === variantId;

      fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`)
        .then((response) => {
          if (listing && !response.ok) throw new Error('Variant section request failed');
          return response.text();
        })
        .then((responseText) => {
          if (listing && !isCurrent()) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          if (listing && !html.getElementById(`price-${this.dataset.section}`)) {
            throw new Error('Variant section response is incomplete');
          }

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        }).catch((error) => {
          if (!listing) { console.error(error); return; }
          if (!isCurrent()) return;
          // Keep purchasing disabled while the selected option's price could be stale.
          this.toggleAddButton(true, this.currentVariant.available ? false : window.theme.variantStrings.soldOut);
          this.productWrapper.querySelector('product-form')?.handleErrorMessage('Could not update this option. Please refresh the page and try again.');
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const scope = this.productWrapper.matches('[data-listing-product]') ? this.productWrapper : document;
      const submitButtons = scope.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const scope = this.productWrapper.matches('[data-listing-product]') ? this.productWrapper : document;
      const submitButtons = scope.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.isListing = this.product_container.hasAttribute('data-listing-product');
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');

      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: false,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        freeScroll: false,
        freeScrollFriction: this.isListing ? 1 : 0.075,
        friction: this.isListing ? 1 : 0.28,
        selectedAttraction: this.isListing ? 1 : 0.1,
        cellAlign: 'left',
        dragThreshold: 3,
        percentPosition: true,
        resize: true,
        watchCSS: false
      };
    }
    init() {
      const isMobile = window.innerWidth <= 767;

      if (isMobile) {
        this.initNativeScroll();
        return;
      }

      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    initNativeScroll() {
      const slides = this.querySelectorAll('.product-images__slide.is-active');

      // 给每张图片添加zoom按钮和页码
      this.createMobileUIForSlides();

      // 存储当前图片索引
      this.currentMobileIndex = 0;

      let scrollTimeout;
      this.addEventListener('scroll', () => {
        // 防抖更新索引和缩略图
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(() => {
          const scrollLeft = this.scrollLeft;
          const slideWidth = this.nativeSlideWidth();
          const currentIndex = slideWidth ? Math.round(scrollLeft / slideWidth) : 0;

          this.currentMobileIndex = currentIndex;
          this.updatePageIndicator(currentIndex);
          this.updateActiveThumbnail(currentIndex);
        }, 50);
      }, { passive: true });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.nativeThumbnailClick(index);
          });
        });
      }, 100);

      this.setupProductGallery();
      const totalSlides = slides.length;
      this.showPageIndicator(1, totalSlides);
    }
    createMobileUIForSlides() {
      // 检查是否在移动端
      if (window.innerWidth > 767) return;

      const slides = this.querySelectorAll('.product-images__slide.is-active');
      const totalSlides = slides.length;

      slides.forEach((slide, index) => {
        // 创建zoom按钮
        const zoomButton = document.createElement('button');
        zoomButton.className = 'mobile-slide-zoom';
        zoomButton.setAttribute('aria-label', 'Zoom');
        zoomButton.setAttribute('type', 'button');
        zoomButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

        // 点击触发该图片的原生zoom
        zoomButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const zoomLink = slide.querySelector('.product-single__media-zoom');
          if (zoomLink) {
            zoomLink.click();
          }
        });

        // 创建页码指示器
        const indicator = document.createElement('div');
        indicator.className = 'mobile-slide-indicator';
        indicator.innerHTML = `<span class="current-slide">${index + 1}</span>/<span class="total-slides">${totalSlides}</span>`;

        // 添加到slide中
        slide.appendChild(zoomButton);
        slide.appendChild(indicator);
      });
    }
    nativeSlideWidth() {
      const slides = this.querySelectorAll('.product-images__slide.is-active');
      return slides[0] ? slides[0].offsetWidth + (parseFloat(getComputedStyle(slides[0]).marginRight) || 0) : 0;
    }
    nativeThumbnailClick(index) {
      const slideWidth = this.nativeSlideWidth();

      this.scrollTo({
        left: slideWidth * index,
        behavior: 'auto'
      });

      this.thumbnails.forEach((el) => {
        el.classList.remove('is-initial-selected');
      });
      const active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
      if (active_thumbs[index]) {
        active_thumbs[index].classList.add('is-initial-selected');
      }
    }
    updatePageIndicator(currentIndex) {
      const indicator = this.product_container.querySelector('.product-slide-indicator');
      if (!indicator) return;

      const currentSlide = indicator.querySelector('.current-slide');
      if (currentSlide) {
        currentSlide.textContent = currentIndex + 1;
      }
      indicator.style.display = 'block';
    }
    updateActiveThumbnail(currentIndex) {
      if (!this.thumbnails) return;

      const active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
      const active_thumb = active_thumbs[currentIndex];

      if (!active_thumb) return;

      // 移除所有选中状态
      this.thumbnails.forEach((el) => {
        el.classList.remove('is-initial-selected');
      });

      // 添加当前选中状态
      active_thumb.classList.add('is-initial-selected');

      // 滚动缩略图容器以显示当前缩略图
      requestAnimationFrame(() => {
        if (active_thumb.offsetParent === null) {
          return;
        }
        const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
          windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
        active_thumb.parentElement.scrollTo({
          left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
          top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
          behavior: this.isListing ? 'auto' : 'smooth'
        });
      });
    }
    showPageIndicator(current, total) {
      const indicator = this.product_container.querySelector('.product-slide-indicator');
      if (!indicator) return;

      const currentSlide = indicator.querySelector('.current-slide');
      const totalSlides = indicator.querySelector('.total-slides');

      if (currentSlide) {
        currentSlide.textContent = current;
      }
      if (totalSlides) {
        totalSlides.textContent = total;
      }
      indicator.style.display = 'block';
    }
    optimizeIOSTouch() {
      const slider = this.querySelector('.flickity-viewport');
      if (!slider) return;

      let startX = 0;
      let startY = 0;
      let isDragging = false;

      slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = false;
      }, { passive: true });

      slider.addEventListener('touchmove', (e) => {
        if (!e.touches[0]) return;

        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = Math.abs(e.touches[0].clientY - startY);

        if (deltaX > deltaY && deltaX > 10 && e.cancelable) {
          isDragging = true;
        }
      }, { passive: true });
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous(false, this.isListing);
        });
        if (prev.tagName !== 'BUTTON') {
          prev.addEventListener('keyup', (event) => {
            this.flkty.previous();
            event.preventDefault();
          });
        }
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next(false, this.isListing);
        });
        if (next.tagName !== 'BUTTON') {
          next.addEventListener('keyup', (event) => {
            this.flkty.next();
            event.preventDefault();
          });
        }
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        const indicator = this.product_container.querySelector('.product-slide-indicator');
        if (indicator && window.innerWidth <= 767) {
          const currentSlide = indicator.querySelector('.current-slide');
          if (currentSlide) {
            currentSlide.textContent = index + 1;
          }
          indicator.style.display = 'none';
        }

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: this.isListing ? 'auto' : 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index, false, this.isListing);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId, false, this.isListing);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      const isMobile = window.innerWidth <= 767;

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          let thumbnail;
          if (isMobile) {
            const slides = this.querySelectorAll('.product-images__slide.is-active');
            const scrollLeft = this.scrollLeft;
            const slideWidth = this.nativeSlideWidth();
            const currentIndex = slideWidth ? Math.round(scrollLeft / slideWidth) : 0;
            thumbnail = slides[currentIndex] || slides[0];
          } else {
            thumbnail = this.querySelector('.product-images__slide.is-selected');
          }

          if (!thumbnail) {
            thumbnail = this.querySelector('.product-images__slide.is-active');
          }

          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      const variantFallback = this.form.querySelector('[data-variant-fallback]');
      if (variantFallback) variantFallback.disabled = true;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const cartDrawer = document.getElementById('Cart-Drawer');
      let mutationFinished = false;
      cartDrawer?.beginMutation?.();

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => {
          if (!response.ok) {
            return response.text().then(text => {
              try { return JSON.parse(text); } catch (e) { throw new Error(`HTTP ${response.status}`); }
            });
          }
          return response.json();
        })
        .then(async (response) => {
          cartDrawer?.endMutation?.();
          mutationFinished = true;

          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          const refreshed = typeof cartDrawer?.queueRefresh === 'function'
            ? await cartDrawer.queueRefresh({ open: false })
            : false;

          if (refreshed) {
            this.openCartDrawer();
          } else {
            this.renderContents(response);
          }

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (!mutationFinished) {
            cartDrawer?.endMutation?.();
          }
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      this.openCartDrawer();
    }
    openCartDrawer() {
      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer?.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.formPassed = false;
      this.footerInView = false;
      this.prefersCompactMode = false;
      this.bodyStateClasses = [
        'has-product-sticky-cart-card',
        'has-product-sticky-cart-circle',
        'has-product-sticky-cart-open'
      ];
    }
    connectedCallback() {
      this.button = this.querySelector('.product-add-to-cart-sticky--inner');
      this.minimizeButton = this.querySelector('.product-add-to-cart-sticky--minimize');
      this.launcherButton = this.querySelector('.product-add-to-cart-sticky--launcher');
      this.content = this.querySelector('.product-add-to-cart-sticky--content');
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.footer = document.getElementById('footer');

      this.setupObservers();
      this.setupToggle();
      this.setupClickOutside();
      this.syncUiState();
    }
    disconnectedCallback() {
      this.clearBodyState();

      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.documentClickHandler) {
        document.removeEventListener('click', this.documentClickHandler);
      }
    }
    clearBodyState() {
      document.body.classList.remove(...this.bodyStateClasses);
    }
    syncUiState() {
      const isVisible = this.classList.contains('sticky--visible');
      const isOpen = this.classList.contains('open');
      const isCompact = this.prefersCompactMode && !isOpen;

      this.classList.toggle('is-minimized', isCompact);

      if (this.button) {
        this.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      if (this.launcherButton) {
        this.launcherButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      if (this.content) {
        this.content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }

      this.clearBodyState();

      if (!isVisible) {
        return;
      }

      if (isOpen) {
        document.body.classList.add('has-product-sticky-cart-open');
      } else if (isCompact) {
        document.body.classList.add('has-product-sticky-cart-circle');
      } else {
        document.body.classList.add('has-product-sticky-cart-card');
      }
    }
    openPanel() {
      if (this.classList.contains('open')) {
        return;
      }

      this.classList.remove('is-minimized');

      if (this.animations_enabled && this.timeline) {
        this.timeline.play(0);
      } else {
        this.classList.add('open');
        this.content?.classList.add('active');
        this.syncUiState();
      }
    }
    closePanel(options = {}) {
      const { immediate = false } = options;

      if (!this.classList.contains('open')) {
        this.syncUiState();
        return;
      }

      if (this.animations_enabled && this.timeline) {
        if (immediate) {
          this.timeline.pause(0);
          this.button?.classList.remove('sticky-open');
          this.classList.remove('open');

          if (this.content) {
            gsap.set(this.content, {
              clearProps: 'height',
              display: 'none'
            });
          }

          this.syncUiState();
          return;
        }

        this.timeline.reverse();
      } else {
        this.classList.remove('open');
        this.content?.classList.remove('active');
        this.syncUiState();
      }
    }
    enterCompactMode() {
      this.prefersCompactMode = true;

      if (this.classList.contains('open')) {
        this.closePanel();
      } else {
        this.syncUiState();
      }
    }
    updateVisibility() {
      const shouldShow = this.formPassed && !this.footerInView;

      this.classList.toggle('sticky--visible', shouldShow);

      if (!shouldShow && this.classList.contains('open')) {
        this.closePanel({ immediate: true });
      } else {
        this.syncUiState();
      }
    }
    setupToggle() {
      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            this.button?.classList.add('sticky-open');
            this.classList.add('open');
            if (this.content) {
              gsap.set(this.content, {
                display: 'block',
                height: 'auto'
              });
            }
            this.syncUiState();
          },
          onReverseComplete: () => {
            this.button?.classList.remove('sticky-open');
            this.classList.remove('open');
            if (this.content) {
              gsap.set(this.content, {
                clearProps: 'height',
                display: 'none'
              });
            }
            this.syncUiState();
          }
        });

        tl
          .fromTo(this.content, {
            height: 0
          }, {
            height: 'auto',
            duration: 0.28,
            ease: 'power1.out'
          }, 0);

        this.timeline = tl;

        if (this.content) {
          gsap.set(this.content, {
            display: 'none'
          });
        }
      }

      this.button?.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.classList.contains('open')) {
          this.closePanel();
        } else {
          this.openPanel();
        }
      });

      this.launcherButton?.addEventListener('click', (e) => {
        e.preventDefault();
        this.openPanel();
      });

      this.minimizeButton?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.enterCompactMode();
      });

      if (!this.animations_enabled) {
        this.button?.addEventListener('click', () => {
          this.syncUiState();
        });
      }
    }
    setupClickOutside() {
      this.documentClickHandler = (e) => {
        if (!this.classList.contains('open')) return;
        if (this.contains(e.target)) return;

        this.closePanel();
      };

      document.addEventListener('click', this.documentClickHandler);
    }
    setupObservers() {
      if (!this.form) {
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.footer) {
            this.footerInView = entry.intersectionRatio > 0;
          }

          if (entry.target === this.form) {
            this.formPassed = this.form.getBoundingClientRect().bottom < 0;
          }
        });

        this.updateVisibility();
      }, {
        threshold: [0, 1]
      });

      this.observer.observe(this.form);

      if (this.footer) {
        this.observer.observe(this.footer);
      }
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
